interface Props {
  size?: number;
  color?: string;
}

const InfoIcon = (props: Props) => {
  const { color = '#000', size = 18 } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_671_16838)">
        <path
          d="M9 13.1667V8.16669"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <path
          d="M8.99999 4.83333C9.46023 4.83333 9.83332 5.20643 9.83332 5.66667C9.83332 6.1269 9.46023 6.5 8.99999 6.5C8.53975 6.5 8.16666 6.1269 8.16666 5.66667C8.16666 5.20643 8.53975 4.83333 8.99999 4.83333Z"
          fill={color}
        />
        <path
          d="M4.83332 1.78154C6.05905 1.0725 7.48216 0.666687 8.99999 0.666687C13.6023 0.666687 17.3333 4.39765 17.3333 9.00002C17.3333 13.6024 13.6023 17.3334 8.99999 17.3334C4.39761 17.3334 0.666656 13.6024 0.666656 9.00002C0.666656 7.48219 1.07246 6.05908 1.78151 4.83335"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_671_16838">
          <rect width={size} height={size} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InfoIcon;
